var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"e2e-scroll-mark",class:_vm.scrollMarkClass})}
var staticRenderFns = []

export { render, staticRenderFns }